module.exports = __webpack_public_path__ + "img/1681390719877.eb2dcf72.jpg";